import parentI18n from "features/parent/i18n";
import { SSO } from "./SSO";

export enum AuthMode {
  Login = "login",
  Signup = "signup",
}

export const AuthMethodSelector = ({
  mode,
  onEmailSelect,
  onModeSwitch,
  onSsoSuccess,
  keepLoadingOnSuccess = false,
}: {
  mode: AuthMode;
  onEmailSelect: () => void;
  onModeSwitch: (mode: AuthMode) => void;
  onSsoSuccess?: () => void;
  keepLoadingOnSuccess?: boolean;
}) => {
  const isSignup = mode === AuthMode.Signup;
  const emailEntryLabel = parentI18n.t(
    isSignup ? "MSG_SIGN_UP_WITH_MAIL" : "MSG_SIGN_IN_WITH_MAIL",
  );
  const switchLabel = parentI18n.t(
    isSignup ? "MSG_SIGN_ALREADY_ACCOUNT_LOGIN" : "MSG_SIGN_NO_ACCOUNT_REGISTER",
  );

  return (
    <div className="flex-col-el items-center w-full gap-6">
      <div className="flex-col-el items-center w-[375px] gap-6">
        <button
          type="button"
          onClick={onEmailSelect}
          className="w-[375px] py-3 bg-green-100 text-white rounded-xl border-none cursor-pointer hover:opacity-90 transition-all type-inherit-font type-text type-body"
        >
          {emailEntryLabel}
        </button>

        <SSO
          signIn={!isSignup}
          onSuccess={onSsoSuccess}
          keepLoadingOnSuccess={keepLoadingOnSuccess}
        />
      </div>

      <button
        type="button"
        onClick={() => onModeSwitch(isSignup ? AuthMode.Login : AuthMode.Signup)}
        className="bg-transparent border-none text-blue-100 hover:text-blue-800 underline cursor-pointer type-inherit-font type-text type-sm"
      >
        {switchLabel}
      </button>
    </div>
  );
};
